function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.0441 9.88673C13.0441 8.9969 12.3313 8.25537 11.4759 8.25537C10.6205 8.25537 9.90771 8.9969 9.90771 9.88673C9.90771 10.7766 10.6205 11.5181 11.4759 11.5181C12.3313 11.5181 13.0441 10.8013 13.0441 9.88673Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.17356 17.7222C8.2686 18.7604 9.59918 18.7604 9.50414 17.7222C9.43285 16.8324 9.45661 15.5224 9.83678 14.5831C9.83678 15.7201 9.83678 16.8571 9.83678 17.9941C9.83678 18.0436 9.83678 18.0683 9.83678 18.1177C9.83678 18.1424 9.83678 18.1424 9.83678 18.1672C9.83678 20.8614 9.83678 23.5803 9.74174 26.2745C9.69422 27.4857 11.2386 27.4609 11.2624 26.2745C11.3337 24.1488 11.3574 22.0478 11.3574 19.9221C11.4287 19.9221 11.5 19.9221 11.5713 19.9221C11.5713 22.0478 11.595 24.1488 11.6663 26.2745C11.7138 27.4609 13.2345 27.4857 13.187 26.2745C13.1157 23.5803 13.1157 20.8614 13.1157 18.1672C13.1157 18.093 13.1157 18.0189 13.0919 17.9447C13.0919 16.7583 13.0444 15.7696 13.0682 14.6078C13.5196 15.5471 13.5672 16.8077 13.4959 17.7222C13.4008 18.7604 14.7552 18.7604 14.8264 17.7222C15.0403 15.2752 14.28 12.0619 11.9514 11.8642C11.595 11.7653 11.2386 11.7653 10.906 11.8642C8.69629 12.1855 7.95971 15.3246 8.17356 17.7222Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M1.59194 1.58203H0V33.4182H1.59194V1.58203Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M22.9997 1.58203H21.4077V33.4182H22.9997V1.58203Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M20.244 29.3643H2.75635V29.7597H20.244V29.3643Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M20.244 5.24023H2.75635V5.63571H20.244V5.24023Z"
});

function SvgElevators(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 35,
    viewBox: "0 0 23 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElevators);
export default __webpack_public_path__ + "static/media/elevators.1290c435.svg";
export { ForwardRef as ReactComponent };